var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_vm._v("\n    "+_vm._s(_vm.$t('this_message_was_replied_ads', { ad_id: _vm.adData.ad_id }))+"\n  ")],_vm._v(" "),(_vm.adData && _vm.adData.ads_context_data && _vm.adData.ads_context_data.ad_title)?_c('div',[_vm._v("\n    AD Title : "+_vm._s(_vm.adData.ads_context_data.ad_title)+"\n  ")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31577835","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/livechat/ReplyAds.vue
// module id = null
// module chunks = 